const keyFor = (userId) => `pinweeloPlaylists:${userId || 'guest'}`

export const entryId = (entry) => String(entry && typeof entry === 'object' ? entry.id : entry || '')

const snapshotFrom = (post) => {
  if (post && typeof post === 'object') {
    return {
      id: String(post.id || ''),
      title: post.title || '',
      thumbnail: post.thumbnail || '',
      type: post.type || 'l',
      image: post.image || ''
    }
  }
  return { id: String(post || '') }
}

export const getPlaylists = (userId) => {
  try {
    const parsed = JSON.parse(localStorage.getItem(keyFor(userId)) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch (err) {
    return []
  }
}

const writePlaylists = (userId, list) => {
  localStorage.setItem(keyFor(userId), JSON.stringify(list))
  return list
}

export const createPlaylist = (userId, name) => {
  const title = String(name || '').trim().slice(0, 40)
  if (!title) return getPlaylists(userId)
  const next = [{
    id: `${Date.now()}`,
    name: title,
    postIds: [],
    created: Date.now()
  }, ...getPlaylists(userId)]
  return writePlaylists(userId, next)
}

export const deletePlaylist = (userId, playlistId) => {
  return writePlaylists(userId, getPlaylists(userId).filter(item => item.id !== playlistId))
}

export const addToPlaylist = (userId, playlistId, post) => {
  const snap = snapshotFrom(post)
  if (!snap.id) return getPlaylists(userId)
  return writePlaylists(userId, getPlaylists(userId).map(item => {
    if (item.id !== playlistId) return item
    if ((item.postIds || []).some(existing => entryId(existing) === snap.id)) {
      return {
        ...item,
        postIds: item.postIds.map(existing => entryId(existing) === snap.id ? { ...snap, ...((typeof existing === 'object' && existing) || {}) } : existing)
      }
    }
    return { ...item, postIds: [...(item.postIds || []), snap] }
  }))
}

export const removeFromPlaylist = (userId, playlistId, postId) => {
  const id = String(postId)
  return writePlaylists(userId, getPlaylists(userId).map(item => {
    if (item.id !== playlistId) return item
    return { ...item, postIds: (item.postIds || []).filter(existing => entryId(existing) !== id) }
  }))
}

export const playlistHas = (playlist, postId) =>
  (playlist.postIds || []).some(existing => entryId(existing) === String(postId))
